import Vue from 'vue'

function updateToHttp2(src) {
  return src.replace('img0.didiglobal.com/static/', 'img0.didiglobal.com/static/')
}

Vue.directive('http2', function (el) {
  el.src = updateToHttp2(el.src)
})
